import type { MailboxInfo } from "owa-client-types";
import { getAsyncItemRegistry } from "./getAsyncItemRegistry";
import { type SeedStatus, type AsyncChatProviderId } from "owa-copilot-async-chat-types";

/** Seed lifecycle of one provider for an account. */
export function getSeedStatus(mailboxInfo: MailboxInfo, providerId: AsyncChatProviderId): SeedStatus {
    return getAsyncItemRegistry(mailboxInfo)?.seedStatusByProvider.get(providerId) ?? "notSeeded";
}

/**
 * Coarse seed lifecycle across every provider that ran for the account, for surfaces (telemetry,
 * empty states) that describe the registry as a whole rather than one service.
 */
export function getOverallSeedStatus(mailboxInfo: MailboxInfo): SeedStatus {
    const statuses = getAsyncItemRegistry(mailboxInfo)?.seedStatusByProvider;
    if (!statuses?.size) {
        return "notSeeded";
    }
    let hasSeeded = false;
    for (const status of statuses.values()) {
        if (status === "inFlight") {
            return "inFlight";
        }
        hasSeeded = hasSeeded || status === "seeded";
    }
    return hasSeeded ? "seeded" : "notSeeded";
}
